import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
import fiabaLogoWebp from "@/assets/fiaba-logo.webp";
import fiabaLogoPng from "@/assets/fiaba-logo.png";

const links = [
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/area-tecnica", label: "Area Tecnica" },
  { to: "/protocolli-intesa", label: "Protocolli" },
  { to: "/fiaba-day", label: "FIABA Day" },
  { to: "/concorsi", label: "Concorsi" },
  { to: "/progettazione-accessibile", label: "Progettazione" },
  { to: "/servizi-comuni", label: "Comuni" },
  { to: "/servizi-aziende", label: "Aziende" },
  { to: "/segnalazioni", label: "Segnalazioni" },
  { to: "/convenzioni", label: "Convenzioni" },
  { to: "/contatti", label: "Contatti" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border">
      <a href="#main" className="skip-link">Salta al contenuto</a>
      <div className="container flex h-20 items-center justify-between gap-4">
        <Link to="/" className="flex items-center" aria-label="FIABA ETS — Home">
          <picture>
            <source srcSet={fiabaLogoWebp} type="image/webp" />
            <img
              src={fiabaLogoPng}
              alt="FIABA ETS — Abbattiamo le barriere"
              className="h-10 sm:h-12 lg:h-14 w-auto"
              width={240}
              height={60}
              fetchPriority="high"
              decoding="async"
            />
          </picture>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Navigazione principale">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                cn(
                  "px-3 py-2 text-sm font-medium rounded-md transition-colors",
                  isActive
                    ? "text-primary bg-muted"
                    : "text-foreground/80 hover:text-primary hover:bg-muted"
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/diventa-socio"
            className="hidden md:inline-flex items-center justify-center rounded-md bg-gold px-4 py-2 text-sm font-semibold text-secondary-foreground shadow-soft hover:opacity-90 transition-opacity"
          >
            Diventa socio
          </Link>
          <button
            className="lg:hidden p-2 text-primary"
            onClick={() => setOpen(!open)}
            aria-label="Apri menu"
            aria-expanded={open}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-border bg-background" aria-label="Menu mobile">
          <div className="container py-4 flex flex-col gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={cn(
                  "px-3 py-3 rounded-md text-sm font-medium",
                  location.pathname === l.to
                    ? "bg-muted text-primary"
                    : "text-foreground/80 hover:bg-muted"
                )}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/diventa-socio"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-md bg-gold px-4 py-3 text-sm font-semibold text-secondary-foreground"
            >
              Diventa socio
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};
